// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__V55ys","amount":"Amount_amount__1MRns","tip":"Amount_tip__1y7PU","tipHeader":"Amount_tipHeader__3hU8E","tipsWrap":"Amount_tipsWrap__3PSbY"};